var map = {
	"./GoalFallback": [
		60802,
		802
	],
	"./GoalFallback.tsx": [
		60802,
		802
	],
	"./Text": [
		35331,
		331
	],
	"./Text.tsx": [
		35331,
		331
	],
	"./ValidationContextStrategy": [
		45050
	],
	"./ValidationContextStrategy.tsx": [
		45050
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1877;
module.exports = webpackAsyncContext;